import { StylePropConfigs } from "../types"

export const animationStyleProps: StylePropConfigs = {
  animationDelay: true,
  animationDirection: true,
  animationDuration: true,
  animationFillMode: true,
  animationIterationCount: true,
  animationKeyframes: true,
  animationPlayState: true,
  animationTimingFunction: true,
  transitionDelay: true,
  transitionDuration: true,
  transitionProperty: true,
  transitionTimingFunction: true,
}

export const borderStyleProps: StylePropConfigs = {
  borderColor: true,
  borderBottomColor: true,
  borderEndColor: true,
  borderLeftColor: true,
  borderRightColor: true,
  borderStartColor: true,
  borderTopColor: true,
  borderRadius: true,
  borderBottomEndRadius: true,
  borderBottomLeftRadius: true,
  borderBottomRightRadius: true,
  borderBottomStartRadius: true,
  borderTopEndRadius: true,
  borderTopLeftRadius: true,
  borderTopRightRadius: true,
  borderTopStartRadius: true,
  borderStyle: true,
  borderBottomStyle: true,
  borderEndStyle: true,
  borderLeftStyle: true,
  borderRightStyle: true,
  borderStartStyle: true,
  borderTopStyle: true,
  rounded: {
    alias: ["borderRadius"],
  },
  borderTopRadius: {
    alias: ["borderTopLeftRadius", "borderTopRightRadius"],
  },
  borderBottomRadius: {
    alias: ["borderBottomLeftRadius", "borderBottomRightRadius"],
  },
  roundedTop: {
    alias: ["borderTopLeftRadius", "borderTopRightRadius"],
  },
  roundedBottom: {
    alias: ["borderBottomLeftRadius", "borderBottomRightRadius"],
  },
}

export const interactionStyleProps: StylePropConfigs = {
  cursor: true,
  touchAction: true,
  userSelect: true,
  willChange: true,
}

export const layoutStyleProps: StylePropConfigs = {
  alignContent: true,
  alignItems: true,
  alignSelf: true,
  backfaceVisibility: true,
  borderWidth: true,
  borderBottomWidth: true,
  borderEndWidth: true,
  borderLeftWidth: true,
  borderRightWidth: true,
  borderStartWidth: true,
  borderTopWidth: true,
  bottom: true,
  boxSizing: true,
  direction: true,
  display: true,
  end: true,
  flex: true,
  flexBasis: true,
  flexDirection: true,
  flexGrow: true,
  flexShrink: true,
  flexWrap: true,
  height: true,
  justifyContent: true,
  left: true,
  margin: true,
  marginBottom: true,
  marginHorizontal: true,
  marginEnd: true,
  marginLeft: true,
  marginRight: true,
  marginStart: true,
  marginTop: true,
  marginVertical: true,
  maxHeight: true,
  maxWidth: true,
  minHeight: true,
  minWidth: true,
  order: true,
  overflow: true,
  overflowX: true,
  overflowY: true,
  padding: true,
  paddingBottom: true,
  paddingHorizontal: true,
  paddingEnd: true,
  paddingLeft: true,
  paddingRight: true,
  paddingStart: true,
  paddingTop: true,
  paddingVertical: true,
  position: true,
  right: true,
  start: true,
  top: true,
  visibility: true,
  width: true,
  zIndex: true,
  gridGap: true,
  gridAutoColumns: true,
  gridAutoFlow: true,
  gridAutoRows: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnGap: true,
  gridColumnStart: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowGap: true,
  gridRowStart: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true,
  m: {
    alias: ["margin"],
  },
  mt: {
    alias: ["marginTop"],
  },
  mr: {
    alias: ["marginRight"],
  },
  mb: {
    alias: ["marginBottom"],
  },
  ml: {
    alias: ["marginLeft"],
  },
  mv: {
    alias: ["marginVertical"],
  },
  mh: {
    alias: ["marginHorizontal"],
  },
  mx: {
    alias: ["marginHorizontal"],
  },
  my: {
    alias: ["marginVertical"],
  },
  p: {
    alias: ["padding"],
  },
  pt: {
    alias: ["paddingTop"],
  },
  pr: {
    alias: ["paddingRight"],
  },
  pb: {
    alias: ["paddingBottom"],
  },
  pl: {
    alias: ["paddingLeft"],
  },
  pv: {
    alias: ["paddingVertical"],
  },
  ph: {
    alias: ["paddingHorizontal"],
  },
  py: {
    alias: ["paddingVertical"],
  },
  px: {
    alias: ["paddingHorizontal"],
  },
}

export const listStyleProps: StylePropConfigs = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: true,
  listStyleImage: true,
  listStyleImg: true,
}

export const shadowStyleProps: StylePropConfigs = {
  shadowColor: true,
  shadowOffset: true,
  shadowOpacity: true,
  shadowRadius: true,
}

export const transformStyleProps: StylePropConfigs = {
  perspective: true,
  perspectiveOrigin: true,
  transform: true,
  transformOrigin: true,
  transformStyle: true,
}

export const viewStyleProps: StylePropConfigs = {
  ...animationStyleProps,
  ...borderStyleProps,
  ...interactionStyleProps,
  ...layoutStyleProps,
  ...listStyleProps,
  ...shadowStyleProps,
  ...transformStyleProps,
  backdropFilter: true,
  backgroundAttachment: true,
  backgroundBlendMode: true,
  backgroundClip: true,
  backgroundColor: true,
  backgroundImage: true,
  backgroundOrigin: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundSize: true,
  boxShadow: true,
  clip: true,
  filter: true,
  opacity: true,
  outlineColor: true,
  outlineOffset: true,
  outlineStyle: true,
  outlineWidth: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  scrollbarWidth: true,
  scrollSnapAlign: true,
  scrollSnapType: true,
  WebkitMaskImage: true,
  WebkitOverflowScrolling: true,
  bg: {
    alias: ["backgroundColor"],
  },
}

export const textStyleProps: StylePropConfigs = {
  ...viewStyleProps,
  color: true,
  fontFamily: true,
  fontFeatureSettings: true,
  fontSize: true,
  fontStyle: true,
  fontWeight: true,
  fontVariant: true,
  letterSpacing: true,
  lineHeight: true,
  textAlign: true,
  textAlignVertical: true,
  textDecorationColor: true,
  textDecorationLine: true,
  textDecorationStyle: true,
  textIndent: true,
  textOverflow: true,
  textRendering: true,
  textShadowColor: true,
  textShadowOffset: true,
  textShadowRadius: true,
  textTransform: true,
  unicodeBidi: true,
  whiteSpace: true,
  wordBreak: true,
  wordWrap: true,
  writingDirection: true,
  /* @platform web */
  MozOsxFontSmoothing: true,
  WebkitFontSmoothing: true,
}

export const svgStyleProps: StylePropConfigs = {
  ...viewStyleProps,
  opacity: false,
  fill: false,
  stroke: false,
  width: false,
  height: false,
}

export const imageStyleProps: StylePropConfigs = {
  ...animationStyleProps,
  ...borderStyleProps,
  ...interactionStyleProps,
  ...layoutStyleProps,
  ...shadowStyleProps,
  ...transformStyleProps,
  backgroundColor: true,
  boxShadow: true,
  filter: true,
  opacity: true,
  resizeMode: true,
  tintColor: true,
  width: false,
  height: false,
}

export const allStyleProps = {
  ...viewStyleProps,
  ...textStyleProps,
}
